import { useDebouncedValue } from "@adafia/ui";
import { Search, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useSearchNotes } from "@/notes/hooks/useSearchNotes";
import type { FileNode } from "../../types";
import "./SearchBar.css";

interface Props {
	onSearchResults: (results: FileNode[] | null) => void;
}

export const SearchBar = ({ onSearchResults }: Props) => {
	const [query, setQuery] = useState("");
	const debouncedQuery = useDebouncedValue(query, 300);
	const { data: searchResults } = useSearchNotes(debouncedQuery);

	useEffect(() => {
		if (!query.trim()) {
			onSearchResults(null);
		}
	}, [query, onSearchResults]);

	useEffect(() => {
		if (debouncedQuery.trim() && searchResults) {
			onSearchResults(searchResults);
		}
	}, [debouncedQuery, searchResults, onSearchResults]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setQuery(e.target.value);
	};

	return (
		<div className="search-bar-container">
			<Search className="search-icon" size={14} />
			<input
				type="text"
				value={query}
				onChange={handleChange}
				placeholder="Search notes or content..."
				className="search-input"
			/>
			{query && (
				<button
					title="Clear search"
					type="button"
					onClick={() => {
						setQuery("");
						onSearchResults(null);
					}}
					className="clear-search-button"
				>
					<X size={14} />
				</button>
			)}
		</div>
	);
};
